/* SBLA Eye Lift Wand landing page: Rebuy Smart Cart add-to-cart and sticky buy bar. */
(function () {
  if (window.__elwInit) return;
  window.__elwInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Add to cart without leaving the page, then open Rebuy Smart Cart.
  // Falls back to the cart page if Smart Cart isn't loaded.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.elw-buy');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var R = window.Rebuy;
        if (R && R.SmartCart) {
          var refresh = R.Cart && typeof R.Cart.fetchCart === 'function' ? R.Cart.fetchCart() : null;
          return Promise.resolve(refresh).then(function () { R.SmartCart.show(); });
        }
        window.location.href = root + 'cart';
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  // Sticky bar: show once the hero has scrolled away, hide while the offer box is on screen.
  function initSticky() {
    var bar = document.querySelector('[data-elw-sticky]');
    var hero = document.querySelector('.elw-hero');
    var offer = document.getElementById('elw-offer');
    if (!bar || !('IntersectionObserver' in window)) return;
    var heroVisible = !!hero, offerVisible = false;
    function update() { bar.classList.toggle('is-visible', !heroVisible && !offerVisible); }
    if (hero) new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; update(); }).observe(hero);
    if (offer) new IntersectionObserver(function (en) { offerVisible = en[0].isIntersecting; update(); }).observe(offer);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();
